import React, { createContext, useContext, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './TimeModal.module.css'; // Подключаем модули стилей

const TimeModalContext = createContext();

export const TimeModalProvider = ({ children }) => {
  const [modalQueue, setModalQueue] = useState([]);

  const openTimeModal = (content, type = 'default') => {
    const id = Date.now();
    setModalQueue((prevQueue) => {
      const updatedQueue = [...prevQueue, { id, content, type }];
      return updatedQueue.slice(-3);
    });

    // Таймер для автоматического закрытия
    setTimeout(() => {
      setModalQueue((prevQueue) => prevQueue.filter((modal) => modal.id !== id));
    }, 3200);
  };

  return (
    <TimeModalContext.Provider value={{ openTimeModal }}>
      {children}
      <div className={styles.modalContainer}>
        <AnimatePresence>
          {modalQueue.map((modal) => (
            <motion.div
              key={modal.id}
              className={`${styles.modalItem} ${styles[modal.type]}`}
              initial={{ y: '-20%', opacity: 0 }}
              animate={{ y: '0%', opacity: 1 }}
              exit={{ y: '-20%', opacity: 0 }}
              transition={{ duration: 0.3 }}
              layout
            >
              <div className={styles.iconCont}>
                {modal.type=='warning' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-octagon"><path fill="#0a469f" d="M12,7a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V8A1,1,0,0,0,12,7Zm0,8a1,1,0,1,0,1,1A1,1,0,0,0,12,15Zm9.71-7.44L16.44,2.29A1.05,1.05,0,0,0,15.73,2H8.27a1.05,1.05,0,0,0-.71.29L2.29,7.56A1.05,1.05,0,0,0,2,8.27v7.46a1.05,1.05,0,0,0,.29.71l5.27,5.27a1.05,1.05,0,0,0,.71.29h7.46a1.05,1.05,0,0,0,.71-.29l5.27-5.27a1.05,1.05,0,0,0,.29-.71V8.27A1.05,1.05,0,0,0,21.71,7.56ZM20,15.31,15.31,20H8.69L4,15.31V8.69L8.69,4h6.62L20,8.69Z"></path></svg>
                  ) : (modal.type=='error' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-triangle"><path fill="#ffffff" d="M12,16a1,1,0,1,0,1,1A1,1,0,0,0,12,16Zm10.67,1.47-8.05-14a3,3,0,0,0-5.24,0l-8,14A3,3,0,0,0,3.94,22H20.06a3,3,0,0,0,2.61-4.53Zm-1.73,2a1,1,0,0,1-.88.51H3.94a1,1,0,0,1-.88-.51,1,1,0,0,1,0-1l8-14a1,1,0,0,1,1.78,0l8.05,14A1,1,0,0,1,20.94,19.49ZM12,8a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V9A1,1,0,0,0,12,8Z"></path></svg>
                  ) : (modal.type=='success' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="check-circle"><path fill="#0a9f3c" d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path></svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-octagon"><path fill="#0a469f" d="M12,7a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V8A1,1,0,0,0,12,7Zm0,8a1,1,0,1,0,1,1A1,1,0,0,0,12,15Zm9.71-7.44L16.44,2.29A1.05,1.05,0,0,0,15.73,2H8.27a1.05,1.05,0,0,0-.71.29L2.29,7.56A1.05,1.05,0,0,0,2,8.27v7.46a1.05,1.05,0,0,0,.29.71l5.27,5.27a1.05,1.05,0,0,0,.71.29h7.46a1.05,1.05,0,0,0,.71-.29l5.27-5.27a1.05,1.05,0,0,0,.29-.71V8.27A1.05,1.05,0,0,0,21.71,7.56ZM20,15.31,15.31,20H8.69L4,15.31V8.69L8.69,4h6.62L20,8.69Z"></path></svg>
                  )))
                }
              </div>
              <div className={styles.textCont}>
                {modal.content}
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </TimeModalContext.Provider>
  );
};

export const useTimeModal = () => useContext(TimeModalContext);
